import { render, staticRenderFns } from "./bottomList.vue?vue&type=template&id=1642356a&scoped=true"
import script from "./bottomList.vue?vue&type=script&lang=js"
export * from "./bottomList.vue?vue&type=script&lang=js"
import style0 from "./bottomList.vue?vue&type=style&index=0&id=1642356a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1642356a",
  null
  
)

export default component.exports